<script>
import Table from './components/NotificationTable'

/**
 * Basic Tables component
 */
export default {
  components: {
    Table,
  },
  data() {
    return {
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null
    }
  }
};
</script>

<template>
  <!-- Table -->
  <div>
    <div v-if="classificationID !== 5">
      <Table :companyID="companyID" />
    </div>

    <div v-else-if="classificationID === 5">
      <DontExist text="se debe calificar la empresa para poder proceder." />
    </div>

    <div v-else>
      <div class="text-center">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>
    </div>

  </div>
</template>